module.exports = __webpack_public_path__ + "img/step12_a_stand_power_on_the_floor.22e7f6ca.png";